module.exports = __webpack_public_path__ + "static/media/temperature_icon.28772b9f.svg";